import * as WebBrowser from 'expo-web-browser';

/**
 * Completes the in-app browser OAuth session so ASWebAuthenticationSession / Chrome tabs
 * dismiss cleanly. Without this, iOS often shows a blank gray screen after redirect.
 *
 * Call once at app startup (see app/_layout.tsx) and after each openAuthSessionAsync returns,
 * and when handling gmail/outlook deep-link callbacks.
 *
 * @see https://docs.expo.dev/versions/latest/sdk/webbrowser/
 */
export function completeOAuthWebSession(): void {
  try {
    WebBrowser.maybeCompleteAuthSession();
  } catch {
    // No active session — safe to ignore
  }
}
